/*TODO: inserire commenti js per descrzione della funziona, di cosa fa e di come usarla*/
//IMPORTANT
//IF YOU WANT TO INSERT A NEW "data-to-be-toggled", THIS CODE HANDLES ONLY SINGLE WORDS
//SO MAKE THE VALUE OF THE OPTION AND THE ATTR BE JUST ONE WORD
//EXAMPLE: NEWTYPE IS OK, NEW TYPE WILL CAUSE ERRORS
//IF YOU WANT AN ELEMENT TO BE AVAILABLE FOR MORE THAN ONE TYPE OF OPTION
//THEN SEPARE THE TYPES WITH ";" LIKE THIS "data-to-be-toggled="filling;processing"
const initToggler = (specificElementAttributeValue) => {
    let elementsToBeToggledArray;
    let togglersArray;
    //if specificElementAttributeValue is passed to the function
    //then i activate the toggler only for that specific element
    if (specificElementAttributeValue) {
        elementsToBeToggledArray = document.querySelectorAll(`[data-to-be-toggled="${specificElementAttributeValue}"]`);
        togglersArray = document.querySelectorAll(`[data-toggler="${specificElementAttributeValue}"]`);
    }
    else {
        elementsToBeToggledArray = document.querySelectorAll("[data-to-be-toggled]");
        togglersArray = document.querySelectorAll("[data-toggler]");
    }
    togglersArray.forEach(toggler => {
        toggler.addEventListener("click", () => {
            console.log("click");
            elementsToBeToggledArray.forEach((element) => {
                console.log(element.getAttribute("data-to-be-toggled").split(";").includes(toggler.getAttribute("data-toggler").toLowerCase()));
                if (element.getAttribute("data-to-be-toggled").split(";").includes(toggler.getAttribute("data-toggler").toLowerCase())) {
                    element.classList.toggle("active");
                }
            });
        });
    });
};
